module.exports = __webpack_public_path__ + "img/seller1.17e0a1df.jpg";